var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_ionic-md-menu","data-name":"Icon ionic-md-menu","d":"M4.5,30.585H36.877v-3.6H4.5Zm0-8.994H36.877v-3.6H4.5ZM4.5,9v3.6H36.877V9Z","transform":"translate(-4.5 -9)"}));
}

Hamburger.defaultProps = {"width":"32.377","height":"21.585","viewBox":"0 0 32.377 21.585"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
